/* Requiere de genesys.js */

var asiento = {
	data () {
		return {
            listAsientos: []
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        getAsiento(fromDate, toDate) {
			let url = this.getApiBackend + this.getGenesys
			let param = {'get': this.urlApiAsiento + '?fromDate=' + fromDate + '&toDate=' + toDate}
            this.axiosActionIS(url, 'POST', 'getAsientoResult', param)
        },
        getAsientoResult(response) {
            this.listAsientos = response.data.asiento
            this.getAsientoResultLocal(response)
        },
        getAsientoResultLocal(response) {
            console.log('getAsientoResultLocal no desarrollado', response)
        },
        getItemAsiento(numasie) {
			let url = this.getApiBackend + this.getGenesys
			let param = {'get': this.urlApiAsiento + 'getAllItem?numasie=' + numasie}
			this.axiosActionIS(url, 'POST', 'getItemAsientoResult', param)
        },
        getItemAsientoResult(response) {
            this.getItemAsientoResultLocal(response)
        },
        getItemAsientoResultLocal(response) {
            console.log(response)
        }
	},
};

export default asiento;